<template>
    <section>
        <div class="footer-panel">
            <div class="footer-block">
                <div class="footer-logo">
                    <img src="../../assets/logo.png" alt="" width="50px" style="margin-right: 10px">
                    <img src="../../assets/text-logo2.png" alt="" width="180px">

                </div>
                <div class="description-block">
                     <span>
                       Интернет-магазин по продаже семян газонных трав ведущих мировых производителей DLF, Barenbrug, Jacklind Seed, DSV и других.
                    </span>
                </div>
                <div class="phone-block">
                    <span>
                        <md-icon>phone</md-icon>  8 (900) 223 20 05
                    </span>
                </div>
                <div class="phone-block">
                    <span>
                        <md-icon>access_time</md-icon>  9:00 - 18:00
                    </span>
                </div>
                <div class="location-block">
                    <md-icon>near_me</md-icon>
                    <span>
                         Тульская область, Алексиноский район, Село Пластово, улица Садовая дом 9
                    </span>
                </div>
            </div>

        </div>
    </section>
</template>

<script>
    export default {
        name: "FooterBar"
    }
</script>

<style scoped lang="scss">

    .footer-panel {
        display: flex;
        flex-direction: column;
        padding: 10px;
        background: #2b2a28;
        .footer-block {
            text-align: left;
            display: flex;
            width: 40vh;
            flex-direction: column;
            justify-content: flex-start;
            .description-block {
                border-bottom: 1px solid #2c3e50;
                padding: 10px 0;
            }
            .phone-block {
                padding: 10px 0;
            }
            .md-icon {
                margin-right: 10px;
            }
            span {
                color:#ffffff;
            }
            .location-block {
                display: flex;
                i {
                    color:#ffffff;
                }
            }
            .footer-logo {
                padding: 10px 0;
            }

            i {
                margin: 0;
            }
        }
    }
</style>
